import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GeneralTable from '../../components/GeneralTable'
import API from '../../services/api';
import { Delete, Edit, People, PermContactCalendar } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CustomSnackBar from '../../components/CustomSnackBar';
import MainText from '../../components/MainText';
import { useDispatch } from 'react-redux';
import { addTab } from '../../tabs/tabsSlice';

export default function ListExecutive() {
    const [executives, setExecutives] = useState([])
    const navigate = useNavigate();
    const [openSnack, setOpenSnack] = useState(false);
    const [loading, setLoading] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("info");


    const columns = [
        {
            label: '#',
            key: 'index',
            align: 'center',
            customRender: (_row, rowIndex) => (
                <Box
                    sx={{
                        display: 'inline-block',
                        minWidth: '24px',
                        px: 1,
                        py: '2px',
                        backgroundColor: '#EEF1F6',
                        color: '#2B3E4D',
                        borderRadius: '8px',
                        fontWeight: 600,
                        fontSize: '0.8rem',
                        fontFamily: 'Segoe UI, Roboto, sans-serif',
                        textAlign: 'center',
                        boxShadow: 'inset 0 0 0 1px rgba(0, 0, 0, 0.06)',
                    }}
                >
                    {rowIndex + 1}
                </Box>
            ),
        },

        { label: 'Nombre', key: 'fullName', align: 'left', format: (row) => `${row.name} ${row.lastName}` },
        { label: 'Empresa', key: 'supplier_name', align: 'right' },
        { label: 'Telefono', key: 'phone', align: 'right' },
        { label: 'Email', key: 'email', align: 'center' },
        { label: 'Puesto', key: 'role', align: 'right' },
        {
            label: 'Acciones',
            key: 'actions',
            align: 'right',
            customRender: (row) => (
                <>
                    <Tooltip title="Eliminar">
                        <IconButton onClick={() => handleDelete(row)} loading={loading}>
                            <Delete color='error' />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar">
                        <IconButton onClick={() => handleEdit(row)}>
                            <Edit color='warning' />
                        </IconButton>
                    </Tooltip>
                </>
            )
        },
    ];

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(addTab({ label: 'Ejecutivos', path: '/suppliers/executive/all-executives' }));
    }, [dispatch]);
    const handleEdit = (row) => {
        navigate('/suppliers/executive/edit-executives', { state: row })

    };

    const handleDelete = async (row) => {
        if (window.confirm('¿Está seguro de eliminar este proveedor?')) {
            try {
                const response = await API.patch(`executive/${row.id}/`, { is_active: 0 });
                setOpenSnack(true);
                setSnackMessage("¡Eliminado con éxito!");
                setSnackSeverity("success");
                setTimeout(() => {
                    setLoading(false);
                    getData();
                }, 1500);

            } catch (error) {
                console.log(error);
                setOpenSnack(true);
                setSnackMessage("Algo salio mal, intente de nuevo");
                setSnackSeverity("error");
                setLoading(false);
            }
        }
    }
    const getData = async () => {
        try {
            const response = await API.get("executive/getActiveExecutives/");
            setExecutives(response.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <MainText
                title={'Ejecutivos'}
                subtitle={'Listado de contactos activos'}
                icon={PermContactCalendar}
            />
            <GeneralTable columns={columns} data={executives} />
            {openSnack && (
                <CustomSnackBar open={openSnack} setOpen={setOpenSnack} message={snackMessage} severity={snackSeverity} />
            )};
        </>

    )
}
